import { configureStore } from "@reduxjs/toolkit"

import ProjectFormReducer from "components/ProjectForm/ProjectFormSlice"
import { api } from "../api"
import { publicApi } from "../api/publicApi"
import AlertReducer from "../components/AlertToaster/AlertSlice"
import RaiseTicketFormReducer from "../components/RaiseTicketForm/RaiseTicketFormSlice"
import LayoutReducer from "../layouts/LayoutSlice"
import AccountReducer from "../pages/Accounts/AccountSlice"
import loginReducer from "../pages/Auth/components/loginSlice"
import ResendOTPReducer from "../pages/Auth/components/ResendOTPSlice"
import verifyLoginReducer from "../pages/Auth/components/verifyLoginSlice"
import CommonReducer from "../pages/Common/commonSlice"
import RolesAccessSlice from "../pages/Common/rolesAccessSlice"
import ComplaintsReducer from "../pages/Complaints/Services/ComplaintsSlice"
import CustomerSupportReducer from "../pages/CustomerSupport/CustomerSupportSlice"
import FinanceReducer from "../pages/Finance/FinanceSlice"
import LogisticsReducer from "../pages/Logistics/LogisticsSlice"
import DispatchRequestReducer from "../pages/DispatchRequest/DispatchRequestSlice"
import WarehouseOutwardReducer from "../pages/WarehouseOutward/WarehouseOutwardSlice"
import NetworkReliabilityReducer from "../pages/NetworkReliability/NetworkReliabilitySlice"
import NotificationSlice from "../pages/Notifications/NotificationSlice"
import OnboardingsReducer from "../pages/Onboardings/OnboardingsSlice"
import DemolitionReducer from "../pages/Operations/features/Demolition/DemolitionSlice"
import DemolitionListReducer from "../pages/Operations/features/Demolition/DemolitionListSlice"
import InstallationReducer from "../pages/Operations/features/Installation/InstallationSlice"
import SurveyReducer from "../pages/Operations/features/Survey/SurveySlice"
import OperationReducer from "../pages/Operations/OperationSlice"
import ProcurementReducer from "../pages/Procurement/ProcurementSlice"
import ProgramsReducer from "../pages/Programs/ProgramsSlice"
import ProjectsReducer from "../pages/Projects/ProjectSlice"
import ProfileReducer from "../pages/Settings/features/Profile/ProfileSlice"
import SideMenuSlice from "../pages/Sidemenu/features/SideMenuSlice"
import SiteReducer from "../pages/Sites/SiteSlice"
import TechSupportReducer from "../pages/TechSupport/TechSupportSlice"
import RoleReducer from "../pages/UserManagement/features/Roles/RoleSlice"
import RolesSetModuleSlice from "../pages/UserManagement/features/Roles/RolesSetModuleSlice"
import VendorReducer from "../pages/UserManagement/userManagementSlice"
import ItemMasterReducer from "../pages/Settings/features/ItemMaster/ItemMasterSlice"
import ApprovalsReducer from "../pages/Approvals/ApprovalsSlice"
import { sentryRejectionMiddleware } from "./sentryMiddleware"

export const store = configureStore({
    reducer: {
        ResendOTP: ResendOTPReducer,
        verifyLogin: verifyLoginReducer,
        login: loginReducer,
        roles: RoleReducer,
        Profile: ProfileReducer,
        procurement: ProcurementReducer,
        vendors: VendorReducer,
        common: CommonReducer,
        Alert: AlertReducer,
        operation: OperationReducer,
        access: RolesAccessSlice,
        SideMenu: SideMenuSlice,
        RolesToggle: RolesSetModuleSlice,
        notification: NotificationSlice,
        Logistics: LogisticsReducer,
        DispatchRequest: DispatchRequestReducer,
        WarehouseOutward: WarehouseOutwardReducer,
        Finance: FinanceReducer,
        Demolition: DemolitionReducer,
        DemolitionList: DemolitionListReducer,
        Installation: InstallationReducer,
        Survey: SurveyReducer,
        CustomerSupport: CustomerSupportReducer,
        TechSupport: TechSupportReducer,
        NetworkReliability: NetworkReliabilityReducer,
        Onboardings: OnboardingsReducer,
        Projects: ProjectsReducer,
        accounts: AccountReducer,
        sites: SiteReducer,
        RaiseTicketForm: RaiseTicketFormReducer,
        complaints: ComplaintsReducer,
        programs: ProgramsReducer,
        ProjectForm: ProjectFormReducer,
        Layout: LayoutReducer,
        itemMaster: ItemMasterReducer,
        Approvals: ApprovalsReducer,
        [api.reducerPath]: api.reducer,
        [publicApi.reducerPath]: publicApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(api.middleware, publicApi.middleware, sentryRejectionMiddleware),
})
export type AppDispatch = typeof store.dispatch
export type TStore = ReturnType<typeof store.getState>
